<script lang="ts">
	import { Button } from '$lib/shadcn/ui/button'
	import { BlocksIcon } from 'lucide-svelte'
	import User from './User.svelte'
	import Video from './Video.svelte'

	export let name: 'Untitled'
	export let user: { username: string }
	export let path = ''
	export let storageUrl = ''
	export let collection: { slug: string }
</script>

<div class="flex flex-col gap-1 h-full min-w-0">
	<div class="relative">
		{#if collection?.slug}
			<Button
				href="/collections/{collection.slug}"
				class="flex gap-1 absolute right-2 bottom-2 z-10"
				variant="secondary"
				size="sm"
			>
				<BlocksIcon strokeWidth="1.5" size="16" />
				Collection
			</Button>
		{/if}
		<a href={path}>
			<Video url={storageUrl} />
		</a>
	</div>
	<div class="flex items-center gap-2 text-sm overflow-hidden">
		{#if user?.username}
			<User size="m" username={user.username} />
		{/if}
		<div class="overflow-hidden whitespace-nowrap overflow-ellipsis">
			{name}
		</div>
	</div>
</div>
